import fetcher from 'api/fetcher';
import { VIEW_DATE_WITHOUT_DAY_YEAR_FIRST_FORMAT } from 'utils/constants/date';
import { formatDate } from 'utils/date';

import urlParser from 'bloko/common/urlParser';

import { ActsSummary, setActsSummary, setAppliedCurrency, setLoadActsSummary } from 'store/models/actsSummary';
import { AppThunkAction } from 'store/utils';

export const fetchActsSummaryReport = (abortSignal?: AbortSignal): AppThunkAction => {
    return (dispatch, getState) => {
        const state = getState();
        const { currentDate, selectedCurrency } = state.actsSummary;

        dispatch(setLoadActsSummary(true));

        const queryStr = urlParser.stringify({
            date: formatDate(currentDate, VIEW_DATE_WITHOUT_DAY_YEAR_FIRST_FORMAT),
            currency: selectedCurrency,
        });

        return fetcher
            .get<unknown, ActsSummary>(`/api/v1/reports/acts/monthly/summary?${queryStr}`, {
                signal: abortSignal,
                timeout: 300000,
            })
            .then((acts) => {
                dispatch([setActsSummary(acts), setLoadActsSummary(false), setAppliedCurrency(selectedCurrency)]);
            });
    };
};
